import React from "react";
import { getUniqueValues } from "../Utilities/JsonFunctions";

export default class FormTableSelectFilter extends React.Component {
    constructor(props) {
        super();
    }

    render() {
        return (
            <div className="select-wrapper">
                <select
                    onChange={event => this.props.onChange(event.target.value)}
                    value={this.props.filter ? this.props.filter.value : ""}>
                    <option value=""></option>
                    {
                        getUniqueValues(this.props.data, this.props.accessor).sort().map((x) =>
                            <option key={x} value={x}>{x}</option>
                        )
                    }
                </select>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/Fields/FormTableSelectFilter.js